(function(){
'use strict';
var D=['Mo','Di','Mi','Do','Fr','Sa','So'], KEY='kaaliq-fussplan-v4';
var S={days:{},m:{},cue:'',start:'',week:1};
try{ var raw=localStorage.getItem(KEY); if(raw) S=Object.assign(S,JSON.parse(raw)); }catch(e){}
function save(){ try{ localStorage.setItem(KEY,JSON.stringify(S)); }catch(e){} }
var mq=window.matchMedia('(max-width:640px)');
var $=function(s){return document.querySelector(s);}, $$=function(s){return [].slice.call(document.querySelectorAll(s));};

/* Tage */
var check='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
$$('.days').forEach(function(row){
  var w=row.dataset.week;
  D.forEach(function(d,i){
    var k=w+'-'+i, el=document.createElement('div');
    el.className='day'+(S.days[k]?' on':'');
    el.innerHTML='<span>'+d+'</span>'+check;
    el.addEventListener('click',function(){ S.days[k]=!S.days[k]; el.classList.toggle('on',S.days[k]); save(); update(); });
    row.appendChild(el);
  });
});

/* Messwerte */
$$('.mform, .mgrid').forEach(function(f){
  var t=f.dataset.t;
  f.querySelectorAll('.minp').forEach(function(inp){
    var k=t+'.'+inp.dataset.f;
    if(S.m[k]) inp.value=S.m[k];
    inp.addEventListener('input',function(){ S.m[k]=inp.value; save(); cmp(); });
  });
});
var LB={schmerz:'Schmerz am Abend',zehen:'Zehen-Test',kraft:'Zehenkraft (kg)',stand:'Einbeinstand (Sek.)',schuhe:'Enge Schuhe'};
function cmp(){
  var t=$('#cmp'); if(!t) return;
  t.innerHTML='<tr><th>Wert</th><th>W 0</th><th>W 4</th><th>W 8</th></tr>';
  Object.keys(LB).forEach(function(f){
    var r=t.insertRow(); r.insertCell().textContent=LB[f];
    ['0','4','8'].forEach(function(p){
      var c=r.insertCell(), v=S.m[p+'.'+f];
      if(v){c.textContent=v;} else {c.textContent='—';c.className='empty';}
    });
  });
}
cmp();

/* Wenn-Dann + Datum */
var cue=$('#cue'); if(S.cue) cue.value=S.cue;
cue.addEventListener('input',function(){ S.cue=cue.value; save(); });
var sd=$('#startdate'); if(S.start) sd.value=S.start;
sd.addEventListener('change',function(){ S.start=sd.value; save(); update(); jumpToCurrent(); });

/* Sheet */
var sheet=$('#sheet'), scrim=$('#scrim');
function openSheet(){ sheet.classList.add('on'); scrim.classList.add('on'); }
function closeSheet(){ sheet.classList.remove('on'); scrim.classList.remove('on'); }
$('#dockbtn').addEventListener('click',openSheet);
$('#sheetx').addEventListener('click',closeSheet);
scrim.addEventListener('click',closeSheet);
document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeSheet(); });

/* Sheet-Menü */
$$('.mitem[data-go]').forEach(function(b){
  b.addEventListener('click',function(){
    var el=document.getElementById(b.dataset.go);
    closeSheet();
    setTimeout(function(){
      if(el) window.scrollTo({top:el.getBoundingClientRect().top+window.pageYOffset-70,behavior:'smooth'});
    },260);
  });
});
var mweeks=$('#mweeks'), wsub=$('#wsub');
mweeks.addEventListener('click',function(){
  mweeks.classList.toggle('open'); wsub.classList.toggle('on');
});

/* Wochenliste */
var weeks=$$('.week');
weeks.forEach(function(el){
  var w=el.dataset.w, title=el.querySelector('h3').textContent;
  var b=document.createElement('button');
  b.type='button'; b.dataset.w=w;
  b.innerHTML='<span class="wn">'+w+'</span><span class="wt">'+title+'</span><span class="wd"></span>';
  b.addEventListener('click',function(){
    setWeek(parseInt(w,10));
    closeSheet();
    setTimeout(function(){
      var t=document.getElementById('w'+w);
      window.scrollTo({top:t.getBoundingClientRect().top+window.pageYOffset-70,behavior:'smooth'});
    },260);
  });
  wsub.appendChild(b);
});

function setWeek(w){
  S.week=w; save();
  if(mq.matches){ weeks.forEach(function(el){ el.hidden=parseInt(el.dataset.w,10)!==w; }); }
  var el=document.getElementById('w'+w);
  $('#dock-n').textContent=w;
  $('#dock-t').textContent=el.querySelector('h3').textContent;
  $('#dock-s').textContent='Woche '+w+' · Programm ansehen';
  $$('#wsub button').forEach(function(b){ b.classList.toggle('sel',parseInt(b.dataset.w,10)===w); });
}
function applyMode(){
  if(mq.matches) setWeek(S.week||1);
  else weeks.forEach(function(el){ el.hidden=false; });
}
if(mq.addEventListener) mq.addEventListener('change',applyMode); else if(mq.addListener) mq.addListener(applyMode);

/* Fortschritt */
var ring=$('#ring'), pct=$('#pct'), bar=$('#bar'), C=65.97;
function update(){
  var n=0; for(var k in S.days){ if(S.days[k]) n++; }
  var p=Math.round(n/56*100);
  pct.textContent=p+'%'; ring.style.strokeDashoffset=C-(C*p/100); bar.style.width=p+'%';
  for(var w=1;w<=8;w++){
    var c=0; for(var i=0;i<7;i++){ if(S.days[w+'-'+i]) c++; }
    var b=document.querySelector('#w'+w+' .wkbar i'); if(b) b.style.width=Math.round(c/7*100)+'%';
    var bt=document.querySelector('#wsub button[data-w="'+w+'"]');
    if(bt){ bt.classList.toggle('done',c>=5); bt.querySelector('.wd').textContent=c+'/7'; }
  }
  var big=$('#bigday'), sub=$('#bigsub'), navday=$('#navday');
  $$('.week').forEach(function(el){ el.classList.remove('current'); });
  $$('.nowbadge.live').forEach(function(el){ el.remove(); });
  navday.textContent='';
  if(S.start){
    var d0=new Date(S.start+'T00:00:00');
    var day=Math.floor((new Date().setHours(0,0,0,0)-d0.getTime())/864e5)+1;
    if(day<1){ big.textContent='Startet bald'; sub.textContent='Dein erster Tag liegt noch vor dir.'; return; }
    if(day>56){ big.textContent='Geschafft'; sub.textContent='Acht Wochen sind um. Weiter unter „Danach".'; return; }
    var wk=Math.min(8,Math.ceil(day/7));
    big.textContent='Tag '+day+' von 56';
    sub.textContent='Du bist in Woche '+wk+'.';
    navday.textContent='Tag '+day;
    var el=document.getElementById('w'+wk);
    if(el){ el.classList.add('current');
      var tag=el.querySelector('.week-tag');
      if(tag){ var b2=document.createElement('span'); b2.className='nowbadge live'; b2.textContent='Diese Woche'; tag.appendChild(b2); } }
  }
}
function jumpToCurrent(){
  if(!S.start) return;
  var d0=new Date(S.start+'T00:00:00');
  var day=Math.floor((new Date().setHours(0,0,0,0)-d0.getTime())/864e5)+1;
  if(day>=1&&day<=56) setWeek(Math.min(8,Math.ceil(day/7)));
}
update(); jumpToCurrent(); applyMode();

/* Übungen aufklappen */
$$('.ex').forEach(function(ex){
  var head=ex.querySelector('.ex-head'), body=ex.querySelector('.ex-body'), inner=ex.querySelector('.ex-in');
  head.addEventListener('click',function(){
    var open=ex.classList.toggle('open');
    body.style.height=open?inner.offsetHeight+'px':'0px';
  });
  window.addEventListener('resize',function(){ if(ex.classList.contains('open')) body.style.height=inner.offsetHeight+'px'; });
});
/* Sprungziel automatisch öffnen */
function openHash(){
  var h=location.hash.replace('#',''); if(!h) return;
  var ex=document.getElementById(h);
  if(ex&&ex.classList.contains('ex')&&!ex.classList.contains('open')){
    ex.classList.add('open');
    ex.querySelector('.ex-body').style.height=ex.querySelector('.ex-in').offsetHeight+'px';
  }
}
window.addEventListener('hashchange',openHash); openHash();

/* Timer */
$$('.tbtn').forEach(function(b){
  var sec=parseInt(b.dataset.sec,10), orig=b.textContent, iv=null;
  b.addEventListener('click',function(e){
    e.stopPropagation();
    if(iv){ clearInterval(iv); iv=null; b.textContent=orig; b.classList.remove('run'); return; }
    var left=sec; b.classList.add('run'); b.textContent=left+' …';
    iv=setInterval(function(){
      left--;
      if(left<=0){ clearInterval(iv); iv=null; b.textContent='✓ fertig'; b.classList.remove('run');
        setTimeout(function(){ b.textContent=orig; },1600); }
      else b.textContent=left+' …';
    },1000);
  });
});

window.resetAll=function(){
  if(!confirm('Alle Häkchen, Messwerte und Eingaben löschen?')) return;
  S={days:{},m:{},cue:'',start:'',week:1}; save();
  $$('.day').forEach(function(d){ d.classList.remove('on'); });
  $$('.minp').forEach(function(i){ i.value=''; });
  cue.value=''; sd.value=''; cmp(); update(); applyMode();
};
})();
